/**
 * @typedef {object} RouteObject
 * @property {string} path     route path
 * @property {Record<string, any>} query    query params
 * @property {Record<string, any>} meta     meta data
 */
/**
 * @typedef {object} NavigateOptions
 * @property {string} path          route path
 * @property {Record<string, any>} [query={}]    query params
 */
/**
 * @callback NavigateHandler
 * @param {{ path: string, query: object }} options
 */
import { RouteManager } from './RouteManager';

/**
 * @callback RouteHandler
 * @param {RouteObject} route
 */
export class Route {
    routeStringifier = RouteManager.instance.routeStringifier;

    path = '';

    query = {};

    /**
     * @private
     */

    constructor({ path = '', query = {} } = {}) {
        this.path = path;
        this.query = query;
    }

    toString() {
        return this.routeStringifier(this);
    }
}
